import { useState } from 'react';
import { ChevronLeft, ChevronRight, Calendar } from 'lucide-react';
import { format, addDays, subDays } from 'date-fns';
import { de } from 'date-fns/locale';

export const DateNavigation = ({ selectedDate, onDateChange }) => {
  const formatDisplayDate = (date) => {
    return format(date, 'EEEE, d. MMMM yyyy', { locale: de });
  };

  const navigateDate = (direction) => {
    const newDate = direction === 'next' 
      ? addDays(selectedDate, 1)
      : subDays(selectedDate, 1);
    onDateChange(newDate);
  };

  const handleToday = () => {
    onDateChange(new Date());
  };

  return (
    <div className="bg-white dark:bg-gray-800 border-b border-gray-200 dark:border-gray-700">
      <div className="mobile-container">
        <div className="flex items-center justify-between py-3 px-4">
          {/* Navigation Buttons */}
          <div className="flex items-center space-x-1 sm:space-x-2 flex-shrink-0">
            <button
              onClick={() => navigateDate('prev')}
              className="p-2 rounded-lg hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors duration-200"
              aria-label="Previous day"
            >
              <ChevronLeft className="w-4 h-4 sm:w-5 sm:h-5" />
            </button>
            
            <button
              onClick={() => navigateDate('next')}
              className="p-2 rounded-lg hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors duration-200"
              aria-label="Next day"
            >
              <ChevronRight className="w-4 h-4 sm:w-5 sm:h-5" />
            </button>
          </div>

          {/* Current Date Display */}
          <div className="flex items-center space-x-2 sm:space-x-3 flex-1 justify-center min-w-0">
            <div className="flex items-center space-x-2 px-3 sm:px-4 py-2 rounded-lg bg-gray-100 dark:bg-gray-700 max-w-full min-w-0">
              <Calendar className="w-4 h-4 flex-shrink-0" />
              <span className="font-medium text-sm sm:text-base hidden sm:block truncate">
                {formatDisplayDate(selectedDate)}
              </span>
              <span className="font-medium text-sm sm:text-base sm:hidden truncate">
                {format(selectedDate, 'dd.MM.yyyy', { locale: de })}
              </span>
            </div>
            
            <button
              onClick={handleToday}
              className="px-2 sm:px-3 py-1 text-xs sm:text-sm bg-primary-500 hover:bg-primary-600 text-white rounded-md transition-colors duration-200 flex-shrink-0"
            >
              Heute
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}; 